var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'app-max-width': _vm.$route.name !== 'Login'},attrs:{"id":"app"}},[_c('transition',{attrs:{"name":"component-fade","mode":"out-in"}},[_c('router-view')],1),(_vm.exibirRodape)?_c('rodape-usuario'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }